/**
 * UCPLayout - Layout для личного кабинета
 */

import React, { useState, useEffect, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuthContext, useUserContext } from "../../contexts";
import UcpMenu from "../menus/UcpMenu";

const UCPLayout = ({ children }) => {
    const { isAuthenticated, logout, loading } = useAuthContext();
    const { donateBalance, isAdmin, fetchDonateBalance } = useUserContext();
    const navigate = useNavigate();
    const [openBurgerFn, setOpenBurgerFn] = useState(null);

    const handleSetOpenBurger = useCallback((openFn) => {
        setOpenBurgerFn(() => openFn);
    }, []);

    useEffect(() => {
        if (loading) return;
        if (!isAuthenticated) {
            navigate("/");
            return;
        }
        fetchDonateBalance();
    }, [isAuthenticated, loading, navigate, fetchDonateBalance]);

    return (
        <div className="app-container app-container--ucp">
            <div className="main-container">
                <header className="ucp-header">
                    <div className="ucp-header-left">
                        <button
                            className="burger-button ucp-burger-button"
                            onClick={() => openBurgerFn && openBurgerFn()}
                            aria-label="Меню"
                        >
                            <div></div>
                        </button>
                        <UcpMenu onTrigger={handleSetOpenBurger} />
                        <div className="logo-container">
                            <Link to="/" onClick={logout}>
                                <img
                                    src="/media/logo_medieval.png"
                                    alt="Logo"
                                />
                            </Link>
                            <div>
                                <span className="logo-container-title logo-container-title--gold">
                                    Medieval
                                </span>
                                <span className="logo-container-title">
                                    Roleplay
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="ucp-header-links">
                        <a
                            href="https://forum.medieval-rp.net/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <span className="ucp-header-link">ФОРУМ</span>
                        </a>
                        <a
                            href="https://wiki.medieval-rp.net/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <span className="ucp-header-link">
                                MEDIEVAL WIKI
                            </span>
                        </a>
                        <Link to="/ucp/shop">
                            <span className="ucp-header-link">МАГАЗИН</span>
                        </Link>
                        <Link to="/ucp/settings">
                            <span className="ucp-header-link">НАСТРОЙКИ</span>
                        </Link>
                    </div>

                    <span className="coin">{donateBalance}</span>
                </header>

                <main>{children}</main>
            </div>
        </div>
    );
};

export default UCPLayout;
